/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface GetUsersFullName$Params {
  ppnUserId: string;
}

export function getUsersFullName(
  http: HttpClient,
  rootUrl: string,
  params: GetUsersFullName$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, getUsersFullName.PATH, 'get');
  if (params) {
    rb.path('ppnUserId', params.ppnUserId, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    }),
  );
}

getUsersFullName.PATH = '/service/v1/user/userFullName/{ppnUserId}';
